'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { BoxCTA } from '@lichtblick/photon/atoms/box-cta/box-cta';
import { Li, Ul } from '@lichtblick/photon/atoms/list/list';
import { Text } from '@lichtblick/photon/atoms/text/text';
import { Checkbox } from '@lichtblick/photon/molecules/checkbox';
import { Textfield } from '@lichtblick/photon/molecules/textfield';
import { useActionState, useEffect, useRef, useState } from 'react';
import { RichText } from '../../helpers/RichText';
import { OInfoteaser } from '../OInfoteaser/OInfoteaser';
import { submitForm } from './actions';
import styles from './kwk-form.module.scss';
const richTextMapperOverride = {
    p: ({ children })=>/*#__PURE__*/ _jsx(Text, {
            renderAs: "p",
            size: "m",
            spacing: true,
            children: children
        }),
    ul: ({ children })=>/*#__PURE__*/ _jsx(Ul, {
            className: styles.ul,
            children: children
        }),
    li: ({ children })=>/*#__PURE__*/ _jsx(Li, {
            className: styles.li,
            children: children
        })
};
const MISSING_DATA_ERROR = 'Hier fehlt noch eine Angabe';
const INCORRECT_DATA_ERROR = 'Hier stimmt was nicht.';
export const KWKForm = ({ aknowledgement, infoTeaser, intro, optin, privacyNote, successTeaser })=>{
    const containerRef = useRef(null);
    const [contractIdChanged, setContractIdChanged] = useState(false);
    const [meterIdChanged, setMeterIdChanged] = useState(false);
    const [state, dispatch, pending] = useActionState(submitForm, {
        submitted: false,
        inputs: {
            contractId: '',
            counterNumber: '',
            emailAddress: '',
            optIn: false
        }
    });
    useEffect(()=>{
        setContractIdChanged(false);
        setMeterIdChanged(false);
    }, []);
    useEffect(()=>{
        if (!state.submitted) {
            return;
        }
        containerRef.current?.scrollIntoView({
            block: 'center'
        });
    }, [
        state.submitted
    ]);
    return state.submitted ? /*#__PURE__*/ _jsx("div", {
        ref: containerRef,
        children: /*#__PURE__*/ _jsx(OInfoteaser, {
            ...successTeaser[0]
        })
    }) : /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            infoTeaser?.length === 1 && /*#__PURE__*/ _jsx(OInfoteaser, {
                ...infoTeaser[0]
            }),
            /*#__PURE__*/ _jsxs("form", {
                action: dispatch,
                className: styles.form,
                children: [
                    /*#__PURE__*/ _jsx(RichText, {
                        elementMappers: richTextMapperOverride,
                        richText: intro
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.contractId,
                        errorMessage: INCORRECT_DATA_ERROR,
                        forcedError: state.errors?.includes('CustomerContractNotFoundError') && !contractIdChanged && !pending ? INCORRECT_DATA_ERROR : undefined,
                        label: "Vertragsnummer",
                        maxLength: 8,
                        name: "contractId",
                        onChange: ()=>{
                            setContractIdChanged(true);
                        },
                        pattern: "\\d{7,8}",
                        required: true
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.counterNumber,
                        errorMessage: INCORRECT_DATA_ERROR,
                        forcedError: state.errors?.includes('CounterNumberNotFoundError') && !meterIdChanged && !pending ? INCORRECT_DATA_ERROR : undefined,
                        label: "Zählernummer",
                        maxLength: 40,
                        name: "meterId",
                        onChange: ()=>{
                            setMeterIdChanged(true);
                        },
                        required: true,
                        type: "text"
                    }),
                    /*#__PURE__*/ _jsx(Textfield, {
                        defaultValue: state.inputs.emailAddress,
                        errorMessage: INCORRECT_DATA_ERROR,
                        label: "E-Mail-Adresse",
                        name: "email",
                        required: true,
                        type: "email"
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        children: /*#__PURE__*/ _jsx(RichText, {
                            elementMappers: richTextMapperOverride,
                            richText: aknowledgement
                        })
                    }),
                    /*#__PURE__*/ _jsx(Checkbox, {
                        errorMessage: MISSING_DATA_ERROR,
                        label: /*#__PURE__*/ _jsx(Checkbox.Label, {
                            children: optin
                        }),
                        children: /*#__PURE__*/ _jsx(Checkbox.Checkbox, {
                            defaultChecked: state.inputs.optIn,
                            name: "optIn",
                            required: true
                        })
                    }),
                    /*#__PURE__*/ _jsx("input", {
                        name: "optInText",
                        type: "hidden",
                        value: optin
                    }),
                    /*#__PURE__*/ _jsx(BoxCTA, {
                        as: "button",
                        loading: pending,
                        type: "submit",
                        children: "Absenden"
                    }),
                    /*#__PURE__*/ _jsx(RichText, {
                        richText: privacyNote
                    })
                ]
            })
        ]
    });
};

//# sourceMappingURL=KWKForm.js.map